/** Treasury API calls (typed). */

import {
  apiDelete,
  apiGet,
  apiPatch,
  apiPost,
  type PaginatedResponse,
  type QueryParams,
} from "@/lib/api-client";
import type {
  ApiBalanceAdjustment,
  ApiMovement,
  ApiReconciliation,
  ApiTreasuryAccount,
} from "./treasury.adapter";

export interface MovementsListParams {
  page?: number;
  limit?: number;
  search?: string;
  accountId?: string;
  type?: string;
  category?: string;
  archived?: boolean;
  sortBy?: string;
  sortOrder?: "asc" | "desc";
}

export const treasuryApi = {
  listAccounts: () =>
    apiGet<{ data: ApiTreasuryAccount[]; totals: Record<string, number> }>("/treasury/accounts"),
  createAccount: (body: Record<string, unknown>) =>
    apiPost<ApiTreasuryAccount>("/treasury/accounts", body),
  updateAccount: (id: string, body: Record<string, unknown>) =>
    apiPatch<ApiTreasuryAccount>(`/treasury/accounts/${id}`, body),
  archiveAccount: (id: string) => apiDelete<ApiTreasuryAccount>(`/treasury/accounts/${id}`),
  listMovements: (params: MovementsListParams = {}) =>
    apiGet<PaginatedResponse<ApiMovement>>("/treasury/movements", params as QueryParams),
  createMovement: (body: Record<string, unknown>) =>
    apiPost<ApiMovement>("/treasury/movements", body),
  transfer: (body: Record<string, unknown>) =>
    apiPost<ApiMovement>("/treasury/movements/transfer", body),
  archiveMovement: (id: string) => apiDelete<ApiMovement>(`/treasury/movements/${id}`),
  restoreMovement: (id: string) => apiPost<ApiMovement>(`/treasury/movements/${id}/restore`),
  reconcile: (body: Record<string, unknown>) =>
    apiPost<ApiReconciliation>("/treasury/reconciliations", body),
  listReconciliations: (accountId?: string) =>
    apiGet<ApiReconciliation[]>("/treasury/reconciliations", accountId ? { accountId } : {}),
  adjustBalance: (accountId: string, body: Record<string, unknown>) =>
    apiPost<ApiBalanceAdjustment>(`/treasury/accounts/${accountId}/adjust`, body),
  listAdjustments: (accountId?: string) =>
    apiGet<ApiBalanceAdjustment[]>("/treasury/adjustments", accountId ? { accountId } : {}),
};
